export default {
  background: '#fff',
  color: '#111',
  colorOnPrimary: '#fff',
  footerBackground: '#1F1F1F',
  footerColor: '#fff',
  primaryColor: '#1f2a30',
  secondaryFooterBackground: '#1F1F1F',
};
